import inspectionEdit from './edit.vue'
import inspectionList from './list.vue'
import inspectioninfo from './info.vue'

import * as templateManagement from './templateManagement'
import * as inspectionCheck from './check.vue'
import * as inspectionchange from './change.vue'
import * as category from './category'
import * as activeInspection from './activeInspection'
import * as inventoryRecord from "./inventoryRecord"

// import * as knowledgeBaseTag from './knowledgeBaseTag'
// import * as comment from './comment'

let a = Object.assign({ inspectionEdit, inspectionList, inspectionCheck, inspectioninfo, inspectionchange }, templateManagement, category, activeInspection, inventoryRecord)
export default a
